import { initConfig, config } from '@finn-no/huck-config'
import { trackEvent } from '@finn-no/pulse-sdk'
import rxios from 'redaxios'

const target = document.getElementById('pf-bfft-links')

;(async () => {
  try {
    if (target.dataset.config) initConfig(target)
    await render(config)
  } catch (err) {
  } finally {
    setupTracking()
  }
})()

async function render({ api }) {
  if (!api) throw "Missing data needed to client-side render pf-bfft-links"
  try {
    const res = await rxios.get(api)
    target.innerHTML = res.data
  } catch (err) {
    console.log("pf-bfft-links caught", err.response)
  }
}

function setupTracking() {
  target.addEventListener('click', track)
  const data = (document.getElementById('pf-bfft-links-rendered') || {}).dataset
}

const pulseTracking = {
  priceOnLoan: 'Price on loan',
  priceOnInsurance: 'Price on insurance'
}

function track(e) {
  const element = e.target.closest('[data-pf-track]')
  if (element) {
    const pulseName = pulseTracking[element.getAttribute('data-pf-track') || '']
    if (pulseName) trackEvent({
      type: 'Click',
      intent: 'Open',
      name: pulseName,
      object: {
        id: config.finncode,
        type: 'UIElement',
        elementType: 'Link'
      }
    })
  }
}

